<template>
  <PageContainer :height="'full'" :size="wide ? 'large' : 'medium'">
    <Card class="onboarding-card" :height="'full'">
      <div class="onboarding-card-header">
        <slot name="header"></slot>
      </div>
      <div class="onboarding-card-body">
        <slot name="body"></slot>
      </div>
      <div class="onboarding-card-footer">
        <slot name="footer"></slot>
      </div>
    </Card>
  </PageContainer>
</template>

<script setup lang="ts">
import { Card, PageContainer } from '@tallo/design-system';

withDefaults(defineProps<{ wide?: boolean }>(), { wide: false });
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.onboarding-card {
  min-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.onboarding-card-body {
  flex-grow: 1;
}

.onboarding-card-footer:not(:empty) {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: var(--t-spacing-sm);
  padding-top: var(--t-spacing-md);

  border-top: 1px solid var(--t-color-border-secondary);

  @include mobile {
    padding-inline: 0;
  }
}

.onboarding-card-footer {
  margin-inline-start: auto;
}
</style>
